$(function(){
	var pageNum = 1;
	
	$('.loadMore').click(function(){
		var url = '/getmore';
		var contentTypes = ['Article'];
		var pageSize = 8;
		var author = $('#authorMore').attr('class').replace(/\-/g,' ');
		pageNum++;
		$.ajax({
			url: url,
			data: {
				contentTypes:contentTypes,
				author:author,
				pageSize:pageSize,
				pageNum:pageNum,
				html:{
					model: article,
					template: "articleWidget"
				}
			},
			success:function(data){
				if(data.Content.length > 0){
					for(var i = 0; i < data.Content.length; i++){
						var $container = $('#authorMore .inlineArticles');
						var $newElement = $('<div class="row">' + data.Content[i] + '</div>').appendTo($container);
						processTimestamp($newElement.find('.timestamp'));
					}
				}
				if(data.Content.length < pageSize) {
					$('.readMoreContainer').parent().hide();
				}
			},
			dataType: "json"
		});
	});
});